/**
 * Homepage redesign: count-up dei numeri ([data-countup]) al primo ingresso
 * in viewport e scroll morbido sull'ancora "Guarda gli ultimi risultati".
 * I valori finali sono già renderizzati server-side: senza JS (o con
 * prefers-reduced-motion attivo) restano semplicemente statici.
 */
(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		var homepage = document.getElementById('homepage');
		if (!homepage) {
			return;
		}

		var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var locale = document.documentElement.lang || 'it';

		// Scroll morbido verso #latest-results
		var anchor = homepage.querySelector('a[href="#latest-results"]');
		var target = document.getElementById('latest-results');
		if (anchor && target) {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
			});
		}

		// Count-up
		var counters = homepage.querySelectorAll('[data-countup]');
		if (!counters.length || reducedMotion || !('IntersectionObserver' in window)) {
			return;
		}

		var DURATION = 1200;

		function animate(el) {
			var end = parseInt(el.getAttribute('data-countup'), 10);
			var suffix = el.getAttribute('data-suffix') || '';
			if (isNaN(end)) {
				return;
			}
			var start = null;

			function step(ts) {
				if (start === null) {
					start = ts;
				}
				var progress = Math.min((ts - start) / DURATION, 1);
				// easing out-cubic
				var eased = 1 - Math.pow(1 - progress, 3);
				var value = Math.round(end * eased);
				el.textContent = value.toLocaleString(locale) + (progress === 1 ? suffix : '');
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			}

			window.requestAnimationFrame(step);
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					animate(entry.target);
				}
			});
		}, { threshold: 0.4 });

		counters.forEach(function (el) {
			observer.observe(el);
		});
	});
})();
